import React from "react";
import { CameraIcon, PhotoIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { FileUploadPermission } from "../CameraCapture/constants";

interface UploadOptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCamera: () => void;
  onPhotoLibrary: () => void;
  permissions: string[] | null;
}

const UploadOptionsModal: React.FC<UploadOptionsModalProps> = ({
  isOpen,
  onClose,
  onCamera,
  onPhotoLibrary,
  permissions
}) => {
  if (!isOpen) return null;

  const showCamera =
    permissions?.some((p) => p.toLowerCase() === FileUploadPermission.camera) ??
    false;
  const showPhotoLibrary =
    !permissions ||
    permissions.some(
      (p) => p.toLowerCase() === FileUploadPermission.choose_from_device
    );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
      <div className="relative bg-white rounded-lg p-6 max-w-sm w-full mx-4">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-semibold">Upload Document</h3>
          <button
            type="button"
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="space-y-3">
          {showCamera && (
            <button
              type="button"
              onClick={onCamera}
              className="flex items-center space-x-3 w-full p-4 text-left border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-indigo-300 transition-colors"
            >
              <div className="p-2 bg-indigo-100 rounded-lg">
                <CameraIcon className="h-6 w-6 text-indigo-600" />
              </div>
              <div>
                <div className="font-medium text-gray-900">Take Photo</div>
                <div className="text-sm text-gray-500">
                  Use camera to capture document
                </div>
              </div>
            </button>
          )}

          {showPhotoLibrary && (
            <button
              type="button"
              onClick={onPhotoLibrary}
              className="flex items-center space-x-3 w-full p-4 text-left border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-indigo-300 transition-colors"
            >
              <div className="p-2 bg-indigo-100 rounded-lg">
                <PhotoIcon className="h-6 w-6 text-indigo-600" />
              </div>
              <div>
                <div className="font-medium text-gray-900">
                  Choose from Photos
                </div>
                <div className="text-sm text-gray-500">
                  Select from your photo library
                </div>
              </div>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UploadOptionsModal;
